// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_get_directions = /** @type {(inputs: {}) => string} */ () => {
	return `Get Directions`
};

const el_get_directions = /** @type {(inputs: {}) => string} */ () => {
	return `Οδηγίες`
};

const ru_get_directions = /** @type {(inputs: {}) => string} */ () => {
	return `Маршрут`
};

const he_get_directions = /** @type {(inputs: {}) => string} */ () => {
	return `הוראות הגעה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const get_directions = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.get_directions(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("get_directions", locale)
	if (locale === "en") return en_get_directions(inputs)
	if (locale === "el") return el_get_directions(inputs)
	if (locale === "ru") return ru_get_directions(inputs)
	if (locale === "he") return he_get_directions(inputs)
	return "get_directions"
};